/**
 * ATS Delete User Dialog Component
 */

import { useState } from 'react';
import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../ui/dialog';
import { toast } from 'sonner';
import { Loader2, Trash2 } from 'lucide-react';

const ATSDeleteUserDialog = ({ api, open, onOpenChange, user, onSuccess }) => {
    const [deleting, setDeleting] = useState(false);

    const handleDelete = async () => {
        if (!user) return;
        
        setDeleting(true);
        try {
            await api.delete(`/ats/users/${user.id}`);
            toast.success('User deleted successfully');
            onSuccess?.();
        } catch (error) {
            toast.error(error.response?.data?.detail || 'Failed to delete user');
        } finally {
            setDeleting(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle>Delete User</DialogTitle>
                    <DialogDescription>
                        Are you sure you want to permanently delete this user? This action cannot be undone.
                    </DialogDescription>
                </DialogHeader>
                {user && (
                    <div className="p-4 rounded-lg border bg-muted/30 my-4">
                        <p className="font-medium">{user.name}</p>
                        <p className="text-sm text-muted-foreground">{user.email}</p>
                    </div>
                )}
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>
                        Cancel
                    </Button>
                    <Button 
                        variant="destructive" 
                        onClick={handleDelete} 
                        disabled={deleting}
                        data-testid="ats-confirm-delete-btn"
                    >
                        {deleting ? (
                            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                        ) : (
                            <Trash2 className="h-4 w-4 mr-2" />
                        )}
                        Delete User
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default ATSDeleteUserDialog;
